module.exports = __webpack_public_path__ + "static/img/title.e2ea5677.png";